import Swiper from 'swiper/core';
import { Navigation, Pagination, Autoplay, EffectCards } from 'swiper/modules';

function initSliders() {
  const productSlider = document.querySelectorAll('.js-product-row');
  if (productSlider.length) {
    productSlider.forEach((slider) => {
      const sliderContainer = slider.closest('.js-slider-container');
      const sliderArrows = sliderContainer.querySelector('.c-arrow');
      let navArrows = false;
      let countArrows = false;
      if (sliderArrows) {
        const next = sliderArrows.querySelector('.js-next');
        const prev = sliderArrows.querySelector('.js-prev');
        const countEl = sliderArrows.querySelector('.c-arrow__count');
        navArrows = {
          nextEl: next,
          prevEl: prev,
        };
        countArrows = {
          el: countEl,
          type: 'fraction',
        };
      }

      new Swiper(slider, {
        modules: [Autoplay, Navigation, Pagination, EffectCards],
        slidesPerView: 'auto',
        effect: 'cards',
        grabCursor: true,
        watchOverflow: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        navigation: navArrows,
        pagination: countArrows,
        breakpoints: {
          320: {
            slidesPerView: 1.2,
          },
          430: {
            slidesPerView: 1.5,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => initSliders());

if (window.acf?.addAction) {
  const rerender = ($el) => initSliders($el[0] || $el); // $el — jQuery, берём нативный dom‑node

  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
